import { number, oneOf, shape, string } from "prop-types"

export const damageType = shape({
    cause: string.isRequired,
    code: string.isRequired,
    geometryTypeid: number.isRequired,
    name: string.isRequired,
    parent: oneOf([null, string]),
})